<template>
  <component :is="activeComponent" v-bind="activeProps" />
</template>

<script setup>
import { defineAsyncComponent, defineProps, shallowRef, watch } from "vue";
import { useStore } from "vuex";
import { isPortalTenantEligibleForHome } from "@/router/portalHomeAccess";

const props = defineProps({
  content: { type: Object, default: null },
  data: { type: Object, default: null },
});

const store = useStore();
const activeComponent = shallowRef(null);
const activeProps = shallowRef({});

const PortalHomePage = defineAsyncComponent(() =>
  import(/* webpackChunkName: "portal-home" */ "@/views/PortalHomePage.vue")
);
const LiteVersion = defineAsyncComponent(() =>
  import(/* webpackChunkName: "lite-version" */ "@/layouts/LiteVersion.vue")
);
const DefaultLayout = defineAsyncComponent(() =>
  import(/* webpackChunkName: "full-version" */ "@/views/Default.vue")
);

function resolveDashboard() {
  if (isPortalTenantEligibleForHome()) {
    activeComponent.value = PortalHomePage;
    activeProps.value = {};
    return;
  }

  activeProps.value = {
    content: props.content,
    data: props.data,
  };

  if (store.getters.isLiteVersion) {
    activeComponent.value = LiteVersion;
  } else {
    activeComponent.value = DefaultLayout;
  }
}

watch(
  () => [store.getters.tenantId, store.getters.isLiteVersion],
  () => resolveDashboard(),
  { immediate: true }
);
</script>
